import ctl from '@netlify/classnames-template-literals'
import { CSSProperties, ReactNode, useContext } from 'react'
import { OutPortal } from 'react-reverse-portal'
import { DemoModeBanner } from './demo-mode-banner'
import { MainNavPortalTargetContext } from './main-nav-context'
import { ModeBannerRow } from './mode-banner'
import { PortalMainNav } from './portal-main-nav'
import { StaffAccessPill, SubscriptionNoticeBar, useSubscriptionNotice } from './subscription-notices'
import { TestingBanner } from './testing-banner'

export type MainNavProps = {
	children: ReactNode
	activeMainNavLink?: 'campaigns' | 'talentPool' | 'analytics' | 'whatsapp' | 'settings'
}
export function MainNav({ children, activeMainNavLink }: MainNavProps) {
	const { mainNavTargetNode } = useContext(MainNavPortalTargetContext)
	const subscriptionNotice = useSubscriptionNotice()

	if (!mainNavTargetNode) {
		throw new Error('No main nav target node')
	}

	return (
		<div
			className={ctl(`
				min-h-screen w-screen relative
				[--main-nav-height:calc(55px+var(--notice-height))]
				[--header-height:var(--main-nav-height)]
				[--screen-height:calc(100vh-var(--header-height))]
			`)}
			style={{ '--notice-height': subscriptionNotice ? '40px' : '0px' } as CSSProperties}
		>
			<div style={{ '--max-width': '1440px' } as CSSProperties}>
				<ModeBannerRow>
					<TestingBanner />
					<DemoModeBanner />
					<StaffAccessPill />
				</ModeBannerRow>
				<div className="sticky top-0 z-20">
					{subscriptionNotice ? <SubscriptionNoticeBar notice={subscriptionNotice} /> : null}
					<div className="bg-white px-10 border-b-[1px] border-grey-100 h-[55px]">
						<OutPortal<typeof PortalMainNav>
							node={mainNavTargetNode}
							activeMainNavLink={activeMainNavLink}
						/>
					</div>
				</div>
				{children}
			</div>
		</div>
	)
}
